import React, { Component } from "react";
import { Form, Select, Upload, Space, message } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import ButtonItem from "../../../../../Components/ButtonItem";
import axios from "axios";
import ModalItem from "../../../../../Components/ModalItem";
import FormItem from "../../../../../Components/FormItem";
import InputItem from "../../../../../Components/InputItem";
import TextAreaItem from "../../../../../Components/TextAreaItem";
import SelectItem from "../../../../../Components/SelectItem";
import CheckItem from "../../../../../Components/CheckItem";
import DatePickerItem from "../../../../../Components/DatePickerItem";

const { Option } = Select;

class AgregarBlog extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    uploadedImageUrl: null,
    fileList: [],
    esAviso: false
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.limpiarFormulario();
    }
  }

  limpiarFormulario = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      uploadedImageUrl: null,
      fileList: [],
      esAviso: false
    });
  };

  // Configuración de upload para imagen
  getUploadProps = () => ({
    name: "imagen",
    accept: "image/*",
    maxCount: 1,
    fileList: this.state.fileList,
    listType: "picture-card",

    beforeUpload: (file) => {
      // Validar que sea una imagen
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('Solo puedes subir archivos de imagen');
        return Upload.LIST_IGNORE;
      }

      // Validar tamaño (máximo 5MB)
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('La imagen debe ser menor a 5MB');
        return Upload.LIST_IGNORE;
      }
      this.setState({ fileList: [file] });
      return false; // No subir automáticamente
    },

    onRemove: () => {
      this.setState({ fileList: [] });
    }
  });

  // Guardar post del blog
  handleSubmit = async (values) => {
    const { empresaId, onSuccess } = this.props;
    const { fileList } = this.state;

    if (fileList.length === 0) {
      message.error("Debes seleccionar una imagen para el post");
      return;
    }

    this.setState({ loading: true });

    try {
      const rawFile = fileList[0];

      const cleanedFile = new File(
        [rawFile], 
        rawFile.name, 
        { type: rawFile.type }
      );

      const formData = new FormData();
      formData.append("imagen", cleanedFile);

      const uploadResponse = await axios.post(
        "/blogs/uploadImagen",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...this.props.headersToken.headers
          }
        }
      );

      if (uploadResponse.data.success !== 2) {
        message.error(uploadResponse.data.message || "Error al subir la imagen");
        this.setState({ loading: false });
        return;
      }

      const imagenUrl = uploadResponse.data.imagenUrl;

      const payload = {
        ...values,
        empresaId,
        imagenUrl,
        fecha: new Date().toISOString(),
        fechaExpiracionAviso: values.fechaExpiracionAviso ? values.fechaExpiracionAviso.toISOString() : null
      };

      const response = await axios.post(
        "blogs/agregarPost",
        payload,
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success("Post agregado correctamente");
        this.limpiarFormulario();
        onSuccess();
      } else {
        message.error(response.data.message || "Error al guardar el post");
      }

    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    this.limpiarFormulario();
    this.props.onCancel();
  };

  render() {
    const { visible } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title="Agregar Post al Blog"
        visible={visible}
        spinning={loading}
        onCancel={this.handleCancel}
        footer={null}
        width={700}
        destroyOnClose
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          onFinish={this.handleSubmit}
          onValuesChange={(changed) => {
            if ("esAviso" in changed) {
              this.setState({ esAviso: changed.esAviso });
            }
          }}
        >
          <FormItem
            name="titulo"
            label="Título del Post"
            rules={[
              { required: true, message: "Ingresa el título" },
              { max: 150, message: "Máximo 150 caracteres" }
            ]}
          >
            <InputItem placeholder="Ej: Nuevas funcionalidades en el sistema" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción corta"
            rules={[
              { required: true, message: "Ingresa la descripción" },
            ]}
          >
            <TextAreaItem 
              rows={3} 
              placeholder="Breve resumen que aparecerá en la tarjeta del post"
            />
          </FormItem>

          <FormItem
            name="contenido"
            label="Contenido completo"
            rules={[
              { required: true, message: "Ingresa el contenido del post" }
            ]}
          >
            <TextAreaItem 
              rows={10} 
              placeholder="Contenido completo del post. Puedes usar HTML básico para formato."
            />
          </FormItem>

          <FormItem
            name="categoria"
            label="Categoría"
            rules={[{ required: true, message: "Selecciona una categoría" }]}
          >
            <SelectItem placeholder="Selecciona una categoría">
              <Option value="Noticias">Noticias</Option>
              <Option value="Actualizaciones">Actualizaciones</Option>
              <Option value="Tutoriales">Tutoriales</Option>
              <Option value="Anuncios">Anuncios</Option>
              <Option value="Tips">Tips</Option>
              <Option value="General">General</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="autor"
            label="Autor"
            rules={[
              { required: true, message: "Ingresa el nombre del autor" },
              { max: 100, message: "Máximo 100 caracteres" }
            ]}
          >
            <InputItem placeholder="Ej: Juan Pérez" />
          </FormItem>

          <FormItem
            name="orden"
            label="Orden de visualización"
            tooltip="Menor número = aparece primero"
            initialValue={0}
          >
            <InputItem type="number" placeholder="0" min={0} />
          </FormItem>

          <FormItem
            label="Imagen destacada"
            required={true}
            extra="Formatos: JPG, PNG, GIF. Máximo 5MB. Recomendado: 1200x630px"
          >
            <Upload {...this.getUploadProps()}>
              <div>
                <PictureOutlined style={{ fontSize: 24 }} />
                <div style={{ marginTop: 8 }}>Subir Imagen</div>
              </div>
            </Upload>
          </FormItem>

          <FormItem name="esAviso" valuePropName="checked" initialValue={false}>
            <CheckItem>Marcar como aviso a todos los usuarios</CheckItem>
          </FormItem>

          {this.state.esAviso && (
            <FormItem
              name="fechaExpiracionAviso"
              label="Vigente hasta"
              required
              tooltip="A partir de esta fecha el aviso deja de mostrarse a los usuarios que no lo hayan visto"
            >
              <DatePickerItem style={{ width: "100%" }} disabledDate={(d) => d && d.isBefore(new Date(), "day")} />
            </FormItem>
          )}

          <FormItem style={{ marginBottom: 0, marginTop: 24 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <ButtonItem onClick={this.handleCancel}>Cancelar</ButtonItem>
              <ButtonItem type="primary" htmlType="submit" loading={loading}>
                Publicar Post
              </ButtonItem>
            </Space>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default AgregarBlog;